import { type Ace, config } from "ace-builds";
import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/mode-json";
import "ace-builds/src-noconflict/theme-github";
import htmlWorkerUrl from "ace-builds/src-noconflict/worker-html.js?url";
import javascriptWorkerUrl from "ace-builds/src-noconflict/worker-javascript.js?url";
import jsonWorkerUrl from "ace-builds/src-noconflict/worker-json.js?url";
import ReactAce, { type IAceEditorProps } from "react-ace";

config.set("loadWorkerFromBlob", false);
config.setModuleUrl("ace/mode/html_worker", htmlWorkerUrl);
config.setModuleUrl("ace/mode/javascript_worker", javascriptWorkerUrl);
config.setModuleUrl("ace/mode/json_worker", jsonWorkerUrl);

type AceEditorProps = Omit<IAceEditorProps, "height"> & {
  ariaLabel?: string;
  height?: number | string;
};

export default function AceEditor({ ariaLabel, height, onLoad, ...props }: AceEditorProps) {
  const normalizedHeight = typeof height === "number" ? `${height}px` : height;
  const handleLoad = (editor: Ace.Editor) => {
    if (ariaLabel) {
      editor.setOption("textInputAriaLabel", ariaLabel);
      editor.textInput.setAriaLabel();
    }
    onLoad?.(editor);
  };

  return <ReactAce {...props} height={normalizedHeight} onLoad={handleLoad} />;
}
